import Command from '@ckeditor/ckeditor5-core/src/command';
import type { Editor } from 'ckeditor5/src/core';

export default class FontSizeCommand extends Command {


	public override value: string | undefined;

	constructor( editor: Editor ) {
		super( editor );
	}

	override refresh() {

		const model = this.editor.model;
		const doc = model.document;
		this.value = doc.selection.getAttribute( 'customFontSize' ) as string;
		this.isEnabled = model.schema.checkAttributeInSelection( doc.selection, 'customFontSize' );

	}

	override execute( newFontSize: number ) {
		const model = this.editor.model;
		const document = model.document;
		const selection = document.selection;

		model.change( writer => {
			if ( selection.isCollapsed ) {
				if ( newFontSize ) {
					writer.setSelectionAttribute( "customFontSize", newFontSize );
				} else {
					writer.removeSelectionAttribute( "customFontSize" );
				}
			} else {
				const ranges = model.schema.getValidRanges( selection.getRanges(), "customFontSize" );

				for ( const range of ranges ) {
					if ( newFontSize ) {
						writer.setAttribute( "customFontSize", newFontSize, range );
					} else {
						writer.removeAttribute( "customFontSize", range );
					}
				}
			}
		} );
	}
}

